export default __webpack_public_path__ + "static/media/FullLogo.4d58d1a0.png";